import React from "react";
import { useSelector, useDispatch } from "react-redux";
import CustomTabset from "../Components/CustomTabset/CustomTabset";
import {globals} from "../Components/Globals/Globals.js";
import { loadArticles } from "../redux/articleSlice.js";
import { Button } from "reactstrap";

// reactstrap components
import {Container, Row} from "reactstrap";

// core components
import ArticlesRawTableDataSync from "../Components/ArticlesRawTableDataSync/ArticlesRawTableDataSync";


const AdminArticlesView = (props) => {
  const dispatch = useDispatch();

  // Get the stats from the store
  const {articlesItems, loadArticles_result} = useSelector((state) => state.articles)
  
  React.useEffect(() => {
    // eslint-disable-next-line no-unused-vars
    let isMounted = true

    // If status is !loading, then fetch stats data from the API
    if (loadArticles_result.status === 'idle'){
      if (globals.parameters.redux_debugging) alert("loading articles")
      dispatch(loadArticles());
    }

    if (loadArticles_result.status === 'loading'){
      if (globals.parameters.redux_debugging) alert("loading articles...")
    }

    // If status is !loading, then fetch stats data from the API
    if (loadArticles_result.status === 'succeeded'){
      if (globals.parameters.redux_debugging) alert("stats successfully loaded")
        console.log("AdminArticlesView -> articlesItems", articlesItems)
    }

    // Cleanup function
    return () => {
      isMounted = false
    }
  }, [loadArticles_result, dispatch]);


  return (    
        <div className="wrapper">
          <div className="main">
            <div className="section">
              <Container>
                {/** Search toolbar */}
                <CustomTabset activeTabset={"articles"}/>
                <Row>
                  <div>
                      {articlesItems  &&
                      <ArticlesRawTableDataSync
                        article_list = {articlesItems}
                        current_session={null}
                        //stat_filter={stat_or_admin_filter()}
                        stat_filter={null}/>}                 
                </div>
                </Row> 
              </Container>
            </div>
          </div>
        </div>
  );
}

export default AdminArticlesView;
